import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles((theme) => ({
    stepBallVerticalNormal : {
      '&> span':{
        '&> span':{
          '&> svg':{
            color:"#286796",
            position:"relative",
            zIndex: 2
            }
          },
        }
      },
    stepBallVerticalEmpty : {
      '&> span':{
        '&> span':{
          '&> svg':{
            fill: "none",
            border: "0.1px",
            borderStyle: "solid",
            borderRadius: "1em",
          }
        },
      }
    },
    stepLabel : {
      '&> span':{
        '&> span':{
          fontSize: '14px',
          fontFamily: 'Roboto',
          fontStyle: 'normal',
          fontWeight: 'bold',
          lineHeight: '16px',
        }
      },
    },
    subDate: {
      marginLeft: '2.6em',
      position: 'absolute',
    },
  }))
export default useStyles
